import React from "react";
import { Link } from "react-router-dom";
import { PlatformIcon } from "components/icons/PlatformIcon";
import styles from "./index.module.scss";
import { PlatformId } from "views/page-content/platforms/types";
import { PlatformsTableProps } from "components/platforms/PlatformsTable";
import { PlatformSubheader } from "./PlatformSubheader";

export const PlatformsTableV2: React.FC<PlatformsTableProps> = ({
    platforms,
    connectText,
    detailsText,
    disconnectText,
    disconnectAction
}: PlatformsTableProps) => {
    return (
        <table className="table table-sm">
            <tbody>
                {platforms.map((p) => {
                    const subheader = PlatformSubheader({
                        platformId: p.Id as PlatformId
                    });
                    return (
                        <tr key={p.Id} className={styles["platform-row"]}>
                            <td>
                                {!p.IsLinked ? (
                                    <div
                                        className={`${styles["platform-link"]} ${styles["disconnected"]}`}
                                    >
                                        <PlatformIcon
                                            platformId={p.Id || ""}
                                            useNewIcon={true}
                                        />
                                        <div
                                            className={styles["platform-info"]}
                                        >
                                            {p.Name}
                                            {subheader && (
                                                <small>
                                                    <p className="mb-2 text-muted">
                                                        {subheader}
                                                    </p>
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        className={`${styles["platform-link"]} ${styles["connected"]}`}
                                    >
                                        <PlatformIcon
                                            platformId={p.Id || ""}
                                            useNewIcon={true}
                                        />
                                        <div
                                            className={styles["platform-info"]}
                                        >
                                            {p.Name}
                                            {subheader && (
                                                <small>
                                                    <p className="mb-2 text-muted">
                                                        {subheader}
                                                    </p>
                                                </small>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </td>
                            <td
                                className={`${styles["text-right"]} text-right`}
                            >
                                {p.IsLinked ? (
                                    p.CanManage ? (
                                        <Link
                                            className={
                                                "btn btn-outline-tertiary"
                                            }
                                            to={p.DashboardUrl}
                                        >
                                            {detailsText}
                                        </Link>
                                    ) : (
                                        <button
                                            className="btn btn-outline-tertiary"
                                            onClick={async () => {
                                                await disconnectAction(
                                                    p.Id as PlatformId
                                                );
                                            }}
                                        >
                                            {disconnectText}
                                        </button>
                                    )
                                ) : (
                                    <Link
                                        className={"btn btn-primary"}
                                        to={`/platforms/connect/${p.Id}`}
                                    >
                                        {connectText}
                                    </Link>
                                )}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
